import {
	FlightClass,
	SeatComfort,
	RowSeatFragment,
	FlightSeatMapRowFragment,
	FlightSeatMapService_OrderAdditionalServiceGdsServiceSeat_Fragment,
	PassengerFragment,
	CheckinPassengerFragment,
	FlightSeatMapFragment,
	OrderAdditionalServicesFragment,
	SeatMapRestrictions,
	SelectedSeatFragment,
	PreselectedSeatFragment,
	AviaPassengerType
} from '@websky/graphql';
import { Money as MoneyType } from '../../../../Money/types';

export type CommonTraveller = PassengerFragment | CheckinPassengerFragment;

export interface ServiceInfo {
	rfics: string;
	comfort: SeatComfort;
	serviceClass: FlightClass;
	minPrice: MoneyType;
}

export enum CustomServiceClass {
	Free = 'Free'
}

export enum CustomSeatComfort {
	Free = 'Free',
	Unavaliable = 'Unavaliable'
}

export type SeatMapFlightClass = FlightClass | CustomServiceClass;

export type SeatMapComfort = SeatComfort | CustomSeatComfort;

export interface SeatMapRowSeat extends RowSeatFragment {
	isFree: boolean;
	combinedWith: CombinedWith;
}

export interface SeatMapRow extends Omit<FlightSeatMapRowFragment, 'seats'> {
	seats: SeatMapRowSeat[];
}

export interface SeatMapGroup {
	services: ServiceInfo[];
	rows: SeatMapRow[];
}

export interface SeatMapSeat {
	price?: MoneyType;
	comfort?: SeatMapComfort;
}

export interface SeatMapService
	extends Omit<FlightSeatMapService_OrderAdditionalServiceGdsServiceSeat_Fragment, 'serviceClass' | 'comfort'> {
	serviceClass?: SeatMapFlightClass;
	seats?: SeatMapSeat[];
	availableRfisc: string[];
}

export interface SelectedSeatsState {
	[segmentId: number]: {
		[passengerId: number]: SelectedSeat[];
	};
}

export interface SelectedSeat {
	segmentId: number;
	passengerId: number;
	row: number;
	letter: string;
	comfort: SeatMapComfort;
	isConfirmed?: boolean;
}

export interface PassengersRecommendedSeats {
	[segmentId: number]: {
		[passengerId: number]: RecommendedSeat[];
	};
}

export interface RecommendedSeat {
	segmentId: number;
	passengerId: number;
	row: number;
	letter: string;
	comfort: SeatMapComfort;
	price: MoneyType;
}

export type CombinedDirection = 'left' | 'right';

export interface CombinedWith {
	[key: string]: CombinedDirection;
}

export interface SeatMapPassenger {
	id: number;
	type?: AviaPassengerType;
	supplierTravellerType?: string;
	firstName: string;
	lastName?: string;
	fullName?: string;
	activeDoubleSeat: boolean;
	selectedSeats: SelectedSeatFragment[];
	preselectedSeats?: PreselectedSeatFragment[];
}

export interface SeatMapPassengersFilters {
	[passengerId: string]: Set<SeatMapRestrictions>;
}

export interface SeatMapState {
	seatMap: FlightSeatMapFragment;
	additionalServices: OrderAdditionalServicesFragment;
	passengers: SeatMapPassenger[];
	selectedPassengerId: number;
	selectedSegmentId: number;
	selectedSeats: SelectedSeatsState;
	selectedPassengersFilters: SeatMapPassengersFilters;
	activeRecommendedSeats: boolean;
	showSuggestionModal: boolean;
}

export type AnyStateWithSeatMap<T = {}> = T & {
	seatMap: SeatMapState;
};

export type SelectedSeatWithPrice = SelectedSeat & { price: MoneyType };

export interface PassengerListItem {
	id: number;
	fullName?: string;
	selectedSeats?: SelectedSeatWithPrice[];
	isSelected: boolean;
	type?: AviaPassengerType;
	supplierTravellerType?: string;
	seatsPrice?: MoneyType;
	activeDoubleSeat: boolean;
	isDisabled?: boolean;
}
